module.exports = __webpack_public_path__ + "img/shopify.9113826.svg";